import {
  MyFilesListParamsType,
  MyFilesListQueryKey,
} from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type';
import { newFilesListQueryFunction } from '@/modules/FileList/queries/newFilesList/newFilesListQueryFunction.ts';
import { getNextPage } from '@/modules/FileList/utils/getNextPage.ts';
import { myFilesListDefaultSelectFunction } from '@/modules/FileList/utils/MyFilesListDefaultSelectFunction.ts';
import { infiniteQueryOptions } from '@tanstack/react-query';

export const newFilesListQueryOptions = (params: MyFilesListParamsType) => {
  const queryParams = {
    [MyFilesListQueryKey.ORDER_ID]: params?.[MyFilesListQueryKey.ORDER_ID],
    [MyFilesListQueryKey.INSURANCE]: params?.[MyFilesListQueryKey.INSURANCE]
      ?.map((item) => item?.value)
      .join(','),
    [MyFilesListQueryKey.PLATE]:
      params?.[MyFilesListQueryKey.PLATE]?.plateString,
    [MyFilesListQueryKey.VEHICLE_TYPE]:
      params?.[MyFilesListQueryKey.VEHICLE_TYPE]?.value,
    [MyFilesListQueryKey.PLATE_DESIGN]:
      params?.[MyFilesListQueryKey.PLATE_DESIGN]?.value,
    [MyFilesListQueryKey.FILE_TYPE]:
      params?.[MyFilesListQueryKey.FILE_TYPE]?.value,
    [MyFilesListQueryKey.PHONE_NUMBER]:
      params?.[MyFilesListQueryKey.PHONE_NUMBER],
    [MyFilesListQueryKey.PAGE]: params?.[MyFilesListQueryKey.PAGE],
    [MyFilesListQueryKey.PAGE_SIZE]: params?.[MyFilesListQueryKey.PAGE_SIZE],
    [MyFilesListQueryKey.SORT]: params?.[MyFilesListQueryKey.SORT]?.value,
  };
  return infiniteQueryOptions({
    queryFn: ({ pageParam }) =>
      newFilesListQueryFunction({ ...queryParams, page: pageParam }),
    queryKey: ['new-files', queryParams],
    initialPageParam: 1,
    getNextPageParam: getNextPage,
    select: myFilesListDefaultSelectFunction,
  });
};
